<!-- Navigation -->

@if (isScreenMedium$$()) {
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="core.navigation$$().vertical"
    [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <div class="flex flex-col items-center justify-center">
        <div
          class="my-4 cursor-pointer rounded-2xl border p-1 hover:shadow"
          matRipple
          (click)="navigateToExpertWorkspaceSelection()">
          <app-expert-workspace-logo-block
            logoSize="md"
            [imageFileKey]="
              core.currentExpertWorkspace$$() | expertWorkspaceImageFileKey
            " />
        </div>
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="flex-0 z-49 bg-card relative flex h-16 w-full items-center px-4 shadow sm:h-20 md:px-6 dark:border-b dark:bg-transparent dark:shadow-none print:hidden">
    @if (!isScreenMedium$$()) {
      <div
        class="mr-2 cursor-pointer rounded-2xl border p-1 hover:shadow"
        matRipple
        (click)="navigateToExpertWorkspaceSelection()">
        <app-expert-workspace-logo-block
          logoSize="md"
          [imageFileKey]="
            core.currentExpertWorkspace$$() | expertWorkspaceImageFileKey
          " />
      </div>
      <!-- Horizontal navigation -->
      <fuse-horizontal-navigation
        class="mr-2"
        [name]="'mainNavigation'"
        [navigation]="core.navigation$$().horizontal" />
    }
    <!-- Navigation toggle button -->
    @if (isScreenMedium$$()) {
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'" />
      </button>
    }
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-2 pl-2">
      <button
        mat-stroked-button
        color="primary"
        appExpertWorkspaceReferralInvitationDeepLinkDetailDialogTrigger>
        친구 초대
      </button>
      <app-expert-event-notification />
      @if (core.currentExpert$$()) {
        <app-color-scheme-menu-button
          [webColorScheme]="core.currentExpert$$().webColorScheme"
          (bySetWebColorScheme)="setWebColorScheme($event)" />
      }
      <user />
    </div>
  </div>
  <!-- Promotion banner-->
  <app-promotion-banner
    title="✨스프린트에 친구 초대하고 친구도 나도 1개월 무료로 사용하기!"
    description="친구가 내 코치 아이디 입력 후 결제하면 각자 무료 크레딧 증정"
    localStorageKey="promoBanner_FriendInvite_April2025">
    <button
      mat-stroked-button
      color="primary"
      appExpertWorkspaceReferralInvitationDeepLinkDetailDialogTrigger>
      친구 초대
    </button>
  </app-promotion-banner>

  <!-- Content -->
  <div class="flex w-full flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet />
    }
  </div>
</div>
